export default __webpack_public_path__ + "static/media/ninjaondemand-logo_white.7e829366.png";